
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E5E5E5","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M-35-256h1440v900H-35z"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{staticClass:"toStroke",attrs:{"d":"M1 19.59a.09.09 0 01-.043-.01 7.21 7.21 0 0114.302 0 .09.09 0 01-.043.01H1zM12.276 6.747a4.168 4.168 0 11-8.335 0 4.168 4.168 0 018.335 0z","fill":"#fff","stroke":"#042132","stroke-width":"1.8"}}),_c('path',{attrs:{"d":"M15.892 13.828a8.61 8.61 0 00-8.544 7.55c-.109.887.626 1.558 1.436 1.558H23c.81 0 1.544-.671 1.435-1.558a8.61 8.61 0 00-8.543-7.55zM16.216 13.369a5.568 5.568 0 100-11.135 5.568 5.568 0 000 11.135z","fill":"#fff","stroke":"#fff"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M8.784 21.537a.09.09 0 01-.043-.01 7.21 7.21 0 0114.302 0 .09.09 0 01-.043.01H8.784zM20.384 7.801a4.168 4.168 0 11-8.336 0 4.168 4.168 0 018.336 0z","fill":"#fff","stroke":"#042132","stroke-width":"1.8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    